var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighestThisYearIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.75,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3650_34214)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.3333,
    height: 24,
    transform: "translate(11.6523 12.75)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5347,
    y: 12.75,
    width: 5.56895,
    height: 24,
    fill: "#B0B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.4958,
    y: 25.4551,
    width: 5.56895,
    height: 11.2941,
    fill: "#B0B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5735,
    y: 21.2207,
    width: 5.56895,
    height: 15.5294,
    fill: "#B0B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4348 31.8913L11.5321 32.3845L12.0248 32.2846C16.7367 31.329 20.4994 27.7439 21.7354 23.0441L22.8305 18.88C23.2384 17.3286 25.3996 17.3286 25.8076 18.88L26.9026 23.0441C28.1386 27.7439 31.9014 31.329 36.6133 32.2846L37.1059 32.3845L37.2032 31.8913L37.4762 30.5069L37.5725 30.019L37.0851 29.9202C33.2725 29.1469 30.219 26.2437 29.215 22.426L28.1199 18.2619C27.083 14.3189 21.555 14.319 20.5181 18.2619L19.423 22.426C18.4191 26.2437 15.3655 29.1469 11.553 29.9202L11.0656 30.019L11.1618 30.5069L11.4348 31.8913Z",
    fill: "#B0B3B3",
    stroke: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4958 25.4551V35.0833H34.0648V30.0067C31.7055 29.0559 29.7516 27.4578 28.4958 25.4551Z",
    fill: "#B0B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1036 21.61L26.2912 18.5208C25.7525 16.4722 22.8857 16.4722 22.347 18.5208L21.5347 21.6097V36.5173H27.1036V21.61Z",
    fill: "#B0B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5735 30.6752V36.4972H20.1424V25.4551C18.8867 27.7519 16.9328 29.5847 14.5735 30.6752Z",
    fill: "#B0B3B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3650_34214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighestThisYearIcon);
export default __webpack_public_path__ + "static/media/HighestThisYearIcon.30cc8bb9d95bf8a7883f04848526b37a.svg";
export { ForwardRef as ReactComponent };